/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import MainCard from "../cards/salesMainCard";
import ResumeCard from "../cards/resumeCard";
import { Navigation, UpdateBar } from "../header/header";
import { Container, Carousel } from "react-bootstrap";
import "../../assets/styles/sale.scss";

class Sale extends React.Component {
  constructor(props) {
    super(props);
    this.user = props.user;
    this.state = {
      data: {},
      productSales: {},
      selections: {},
      someVar: false,
      ticket: localStorage.getItem('urlQlik')
    };
    this.d = "";
    this.ws = this.props.ws;
    this.handler = this.handler.bind(this);
  }
  handler() {
    this.setState({
      update: !this.state.update
    });
  } 
  render() {
    if (window.innerWidth <= 768) {
      // ! si es Mobile
      return (
        <div>
          <Navigation title={this.props.title} handler={this.handler} ws={this.ws} />
          <div className="w-100 px-4 py-1 bg-white shadow-1 anuncio">Última vez actualizado: <strong className="ml-0 -2">4 de Enero del 2020 8:40 AM</strong></div>
            <div className="pb-5 pt-3 pl-5">
              <h3 className="title mb-0">BIENVENIDO</h3>
              <h4 className="mb-0">Al portal de análisis</h4>
            </div>
            <div className="bg-fondo pb-5">
              <div className="offset-0 col-12 col-md-8 offset-md-5">
                <Carousel>
                  <Carousel.Item>
                    <div className="row">
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/comercial.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Comercial</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-comercial.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-comercial/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/social-care.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Niveles de servicio</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-niveles-de-servicio.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-niveles-servicio/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div className="row">
                    <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/social-care.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Niveles de Servicio</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-niveles-de-servicio.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-niveles-servicio/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Cobranza</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-cobranza.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-cobranza/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div className="row">
                    <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Cobranza</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-cobranza.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-cobranza/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Compras</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-produccion.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-compras/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div className="row">
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Compras</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-produccion.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-compras/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/inventarios.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Inventarios</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-inventarios.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-inventarios/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div className="row">
                      <div className="col-6 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/inventarios.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Inventarios</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-inventarios.jpg")}></img>
                          <a href={'https://71.6.202.19/extensions/presto-inventarios/index.html?qlikTicket=' + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                </Carousel>
              </div>
            </div>
          </div>
      )
    }
    else {
      // ! si es desktop
      return (
        <div>
          <Navigation title={this.props.title} handler={this.handler} ws={this.ws} />
          {/* <div className="w-100 px-4 py-1 text-right bg-white shadow-1 anuncio">Anuncio: La planta Tijera suspenderá operaciones la semana del 25 al 1 de enero del 2020 para mantenimiento</div> */}
            <div className="py-5 pl-5">
              <h3 className="title mb-0">BIENVENIDO</h3>
              <h4 className="mb-0">Al portal de análisis</h4>
            </div>
            <div className="bg-fondo pb-5">
              <div className="offset-0 col-12 col-md-8 offset-md-5">
                <Carousel>
                  <Carousel.Item>
                    <div className="row">
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/comercial.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Comercial</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-comercial.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-comercial/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/social-care.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Niveles de servicio</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-niveles-de-servicio.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-niveles-servicio/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>  
                        </div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Cobranza</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-cobranza.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-cobranza/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div className="row">
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Cobranza</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-cobranza.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-cobranza/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Compras</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-produccion.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-compras/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/inventarios.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Inventarios</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-inventarios.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-inventarios/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                  <Carousel.Item>
                    <div className="row">
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/bill.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Compras</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-produccion.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-compras/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <div className="card-login shadows">
                          <div className="d-flex align-items-center">
                            <div className="card-icon d-flex align-items-center justify-content-center mr-4 shadows">
                              <img className="img-fluid" alt="Presto" src={require("../../components/login/img/inventarios.svg")}></img>
                            </div>
                            <h4 className="card-title mb-auto mt-4">Inventarios</h4>
                          </div>
                          <img className="card-img" alt="Presto" src={require("../../components/login/img/login-inventarios.jpg")}></img>
                          <a href={"https://71.6.202.19/extensions/presto-inventarios/index.html?qlikTicket=" + this.state.ticket} className="text-white bienvenido-btn text-center btn w-100">
                            Entrar
                          </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                </Carousel>
              </div>
            </div>
          </div>
        )
    }
  }
}
export default Sale;
